import { urlPathname } from './utils';
import { mainordersum } from './mainordersum';
import { mainindex } from './mainindex';
import { mainfinal } from './mainfinal';
import { mainprofile } from './mainprofile';
import { mainregister } from './mainregister';
import { mainpassword } from './mainpassword';
import { bindLoginHandler } from './login';

if (urlPathname().includes('ordersum')) {
  setTimeout(() => {
    console.log('mainordersum');
    mainordersum();
  }, 100);
} else if (urlPathname().includes('profile')) {
  setTimeout(() => {
    console.log('mainprofile');
    mainprofile();
  }, 100);
} else if (urlPathname().includes('final')) {
  setTimeout(() => {
    console.log('mainfinal');
    mainfinal();
  }, 100);
} else if (urlPathname().includes('register')) {
  setTimeout(() => {
    console.log('mainregister');
    mainregister();
  }, 100);
} else if (urlPathname().includes('pass')) {
  setTimeout(() => {
    console.log('mainpassword');
    mainpassword();
  }, 100);
} else {
  setTimeout(() => {
    console.log('mainindex');
    mainindex();
  }, 100);
}
setTimeout(() => {
  bindLoginHandler();
}, 100);
